var map = {
	"./custom.png": "1afd",
	"./htronic_03A.png": "3829",
	"./ngr_nxr_5A.png": "eb6d",
	"./victron_20A.png": "bcca",
	"./victron_24A_24V.png": "f0de",
	"./victron_30A.png": "e5f8",
	"./victron_8A_24V.png": "90e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73f9";